import React from "react";
import { connect } from "react-redux";

import { DialogButton, HubBackButton, HubButton } from "../../components";
import { setIsOpenDialog } from "../../redux";

import {
  StyledHubButtonGroup,
  StyledTitledSubStack,
  StyledTitleStack,
} from "./styles";

const VIEW_MODES = [
  { id: 0, label: "Board", icon: "CreditCard" },
  { id: 1, label: "Table", icon: "List" },
];

const SalesBar = ({ tab = 0, viewMode = 0, setViewMode = () => {} }) => {
  const isLeads = tab === 0;

  return (
    <StyledTitleStack>
      <StyledTitledSubStack disableYPadding>
        <HubBackButton />
        <StyledHubButtonGroup
          buttons={VIEW_MODES}
          selected={viewMode}
          setSelected={setViewMode}
          buttonProps={{ variant: "outlined" }}
          allowNeutral
        />
      </StyledTitledSubStack>
      <StyledTitledSubStack>
        {isLeads ? (
          <DialogButton
            name="edit-lead"
            label="Create Lead"
            icon="Users"
            variant="contained"
            color="neutral"
            size="xsmall"
            iconProps={{ size: "10px" }}
          />
        ) : (
          <HubButton
            label="Create Quote"
            icon="Settings"
            variant="contained"
            color="neutral"
            size="xsmall"
            iconProps={{ size: "10px" }}
            page="/quotes"
          />
        )}
      </StyledTitledSubStack>
    </StyledTitleStack>
  );
};

const mapDispatchToProps = { _setIsOpenDialog: setIsOpenDialog };
export default connect(null, mapDispatchToProps)(SalesBar);
